import {round} from "lodash"
import {PaymentProvider} from "types/student-account/student-payment"
import {StudentTransaction, StudentTransactionType} from "types/student-account/student-ledger"

/** Returns whether a transaction is a reference-only pending manual payment. */
export const isPendingManualPayment = (transaction: StudentTransaction): boolean =>
    transaction.type === StudentTransactionType.Payment &&
    transaction.payment?.status === "pending" &&
    transaction.payment.provider === PaymentProvider.Manual

/** Applies running balances and returns totals, excluding reference-only pending manual payments. */
export const calculateStudentTransactionBalances = (
    transactions: StudentTransaction[]
): {chargeTotal: number; paymentTotal: number; latestBalance: number | undefined} => {
    let chargeTotal = 0
    let paymentTotal = 0

    transactions.forEach((transaction, index) => {
        const previousBalance = transactions[index - 1]?.balance || 0
        switch (transaction.type) {
            case StudentTransactionType.Charge:
                chargeTotal = round(chargeTotal + transaction.amount, 2)
                transaction.balance = round(previousBalance + transaction.amount, 2)
                break
            case StudentTransactionType.Payment:
                if (isPendingManualPayment(transaction)) {
                    transaction.balance = previousBalance
                    break
                }
                paymentTotal = round(paymentTotal + transaction.amount, 2)
                transaction.balance = round(previousBalance - transaction.amount, 2)
                break
        }
    })

    return {
        chargeTotal,
        paymentTotal,
        latestBalance: transactions[transactions.length - 1]?.balance
    }
}
